const ITEM_TYPE = {
  ROOM: 1,
  PARKING: 2,
  COMMON_ROOM: 3,
  LOCKER: 4,
};

export default ITEM_TYPE;
